import useQuery from '../../useQuery';

/**
 * The users supporting one group, read under the design naming it.
 *
 * @param {String} designId
 * @param {String} groupId
 * @returns {Object}
 */
export default function useGroupSupporters(designId, groupId, enabled = true) {
  const path = `v1/designs/${designId}/groups/${groupId}/supporters`;

  async function getSupporters() {
    return await this.get(path);
  }

  return useQuery(path, getSupporters, {
    staleTime: 5 * 60 * 1000, // 5m
    dataKey: 'supporters',
    dataDefault: [],
    enabled: Boolean(enabled && designId && groupId),
  });
}
